import React, { useContext } from 'react'
import { IdentityContext } from '#src/containers/Identity'
import { Grid, GridItem } from '@deal/components'
import Logo from '#src/components/Header/common/Logo'
import LoggedInNavigation from './LoggedInNavigation'
import LoggedOutNavigation from './LoggedOutNavigation'
import GlobalNavigation from './GlobalNavigation'
import styles from './styles.css'

const Desktop: React.FC = () => {
  const { myself } = useContext(IdentityContext)

  return (
    <Grid>
      <GridItem col={2}>
        <div className={styles.wrapper}>
          <div className={styles.logoWrapper}>
            <Logo showIconMark={false} showDepartment={false} className={styles.logoMark} />
          </div>

          <div className={styles.navWrapper}>
            <GlobalNavigation />
          </div>

          <div className={styles.navWrapper}>
            {myself ? <LoggedInNavigation /> : <LoggedOutNavigation />}
          </div>
        </div>
      </GridItem>
    </Grid>
  )
}

export default Desktop
